export default __webpack_public_path__ + "static/media/cocktail1.248dcdec.jpg";